import { URLS } from "../../Utilities/Maps";

export const isSupportedPage = (path: string) => {
  const urls = ["/u", URLS.CLIPS, URLS.PROFILE, URLS.UPGRADE];
  return urls.includes(path.split(/(?=\/)/g)[0]);
};
